/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const AttachmentTypeDto = {
    CakeInstallation: 'CAKE_INSTALLATION',
    Christmas2026: 'CHRISTMAS_2026',
    GeneralOffer: 'GENERAL_OFFER',
    GrazingTable: 'GRAZING_TABLE',
    Easter2026Offer: 'EASTER_2026_OFFER',
    Easter2026Album: 'EASTER_2026_ALBUM',
} as const;

export type AttachmentTypeDto = typeof AttachmentTypeDto[keyof typeof AttachmentTypeDto];



